import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";

export default function NewsPage() {
  const { id } = useParams();
  const [news, setNews] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/public/news/${id}`).then((r) => setNews(r.data)).catch(() => setError(true));
  }, [id]);

  return (
    <div className="min-h-screen bg-[#FAF7F2] flex items-center justify-center p-4 font-sans">
      <div className="bg-white rounded-3xl border border-[#E8E2D9] shadow-[0_20px_60px_rgb(74,63,63,0.08)] max-w-lg w-full overflow-hidden">
        <div className="bg-brand px-8 py-6 text-white">
          <div className="text-lg font-display tracking-wide">Nelleke Holt Beauty &amp; Massage</div>
        </div>
        <div className="p-8">
          {error && <p className="text-ink-muted text-sm text-center py-6">Dit bericht is niet gevonden.</p>}
          {!error && !news && <div className="text-center py-8"><Loader2 className="w-6 h-6 animate-spin text-brand mx-auto" /></div>}
          {news && (
            <>
              <div className="inline-block bg-brand-light text-brand text-[11px] tracking-widest px-3 py-1 rounded-full mb-3">NIEUWS</div>
              <h1 className="text-2xl font-display mb-4">{news.subject}</h1>
              <p className="text-ink leading-relaxed whitespace-pre-line">{news.body}</p>
              <p className="text-ink-muted mt-8 text-sm">Warme groet,<br />Nelleke</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
